import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Banner } from '@plurall/elo-beta'
import { getEnvironmentName } from 'utils/token'

import PrivacyFooter from 'components/PrivacyFooter'

import styles from './Layout.module.scss'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'

const Layout = ({ children }) => {
  const { content } = styles
  const [bannerMaintenance, setBannerMaintenance] = useState(null)

  useEffect(() => {
    const init = async () => {
      const currentDate = new Date()
      const getHours = currentDate.getHours()
      const getMinutes = currentDate.getMinutes()
      const getTime = `${getHours}_${getMinutes}`
      const data = await fetch(
        `https://assets.cdn.plurall.net/ft/maintence/${getEnvironmentName()}.json?v=${getTime}`,
      )
        .then(res => res.json())
        .catch(e => console.warn(e))
      if (data) {
        const { under_maintenance: underMaintenance } = data

        if (underMaintenance.enabled) {
          setBannerMaintenance(underMaintenance)
        }
      }
    }
    init()
  }, [])

  return (
    <ErrorBoundary>
      <>
        {bannerMaintenance && (
          <Banner
            type='top'
            title={bannerMaintenance.title}
            variant={bannerMaintenance.type_banner}
          >
            {bannerMaintenance.text}
          </Banner>
        )}

        <div
          className={content}
          style={bannerMaintenance ? { minHeight: 'calc(100vh - 56px)' } : {}}
        >
          {children}
        </div>

        <PrivacyFooter />
      </>
    </ErrorBoundary>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
